<ng-container *ngIf="isLoadingPermissions; else loadedPermissions">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
</ng-container>
<ng-template #loadedPermissions>
    <app-data-grid-comp
        [columns]="columns"
        [filterCategories]="filterCategories"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        [category]="db_tables.BackgroundChecks"
        [clearSelectedItems]="clearSelectedItems"
        [tableId]="db_tables.BackgroundChecks"
        [accessAndHistoryURL]="accessAndHistoryURL"
        [parentModelId]="employeeID"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
        (emitPageChangeEvent)="pageChange($event)"
        (emitOpenDialogEvent)="getBackgroundCheck($event)"
        (emitDeleteEvent)="deleteBackgroundChecks($event)"
        (emitFilterEvent)="filterCallback($event)"
        (emitSortEvent)="sortChange($event)"
    ></app-data-grid-comp>
</ng-template>